import api from "../../Hooks/axiosApi";

export const createSuburbService = (data: any) => {
    return api.post('/api/Property/CreateSuburb', data);
};

export const updateSuburbService = (data : any) => {
    return api.put(`/api/Property/UpdateSuburb`, data);
};

export const deleteSuburbService = (id: any) => {
    return api.delete(`/api/Property/SoftDeleteSuburb/${id}`);
};

export const getAllActiveSuburbsService = () => {
    return api.get('/api/Property/GetAllActiveSuburbs');
};

export const getSuburbByIdService = (id: any) => {
    return api.get(`/api/Property/GetSuburbById/${id}`);
};
